exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Vq1Fy8Zl0zbgpAiUXPPH8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}._3Vq1Fy8Zl0zbgpAiUXPPH8 ._39RDXilp41y37Apk9QH7h0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}html[dir=ltr] ._3Vq1Fy8Zl0zbgpAiUXPPH8 ._39RDXilp41y37Apk9QH7h0{margin:24px 28px 0 0}html[dir=rtl] ._3Vq1Fy8Zl0zbgpAiUXPPH8 ._39RDXilp41y37Apk9QH7h0{margin:24px 0 0 28px}html[dir=ltr] ._3Vq1Fy8Zl0zbgpAiUXPPH8 ._39RDXilp41y37Apk9QH7h0 .LcK_RWXhPUD4yX-mo1aId{margin-right:14px}html[dir=rtl] ._3Vq1Fy8Zl0zbgpAiUXPPH8 ._39RDXilp41y37Apk9QH7h0 .LcK_RWXhPUD4yX-mo1aId{margin-left:14px}", ""]);

// exports
exports.locals = {
	"container": "_3Vq1Fy8Zl0zbgpAiUXPPH8",
	"buttonsContainer": "_39RDXilp41y37Apk9QH7h0",
	"primaryButton": "LcK_RWXhPUD4yX-mo1aId"
};